import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormRenderProps } from 'react-final-form';

import PageBaseProps from 'types/PageBase';
import FormKeys from 'modules/form/types/FormKeys';
import { AbstractMedia } from 'types/AbstractMedia';
import { ExtrasForm as ExtrasFormType } from 'types/ExtrasForm';

import { UPDATE_FIXED_CACHE_KEY } from 'modules/selfServices/constants';

import { useUpdateSelfServiceMutation } from 'modules/selfServices/service';

import Advices from 'components/Advices';
import PageFooter from 'components/ui/PageFooter';
import DefaultExtra from 'assets/images/default-extra.jpg';

type ExtrasFormRenderProps = FormRenderProps<ExtrasFormType>
  & Pick<PageBaseProps, 'onPrev' | 'shouldDisplayBackButton' | 'isPenultimate'>
  & { formKey: FormKeys };

const ExtrasFormRender: React.FC<ExtrasFormRenderProps> = ({
  handleSubmit, hasValidationErrors, onPrev, shouldDisplayBackButton, isPenultimate, formKey,
}) => {
  const [, { isLoading: isUpdateLoading }] = useUpdateSelfServiceMutation({ fixedCacheKey: UPDATE_FIXED_CACHE_KEY });

  return (
    <div className="main-content">
      <main>
        <p className="text-center text-low">
          <FormattedMessage
            id="extras.indication"
            // eslint-disable-next-line max-len
            defaultMessage="Here are some additional services that may interest you. Accepting any of these options will add them to your total payment."
          />
        </p>
        <div className="content">
          <ul className="md:grid-cols-2 gap-5 justify-center grid">
            <Advices
              name="extras"
              formKey={formKey}
              mediaPlaceholder={{
                id: '1',
                type: 'IMAGE',
                path: DefaultExtra,
              } as AbstractMedia}
            />
          </ul>
        </div>
      </main>
      <PageFooter
        onPrev={onPrev}
        onNext={handleSubmit}
        loading={isUpdateLoading}
        isPenultimate={isPenultimate}
        disabledStyle={hasValidationErrors}
        shouldDisplayBackButton={shouldDisplayBackButton}
        hint={(
          <FormattedMessage
            id="extra.footer.indication"
            defaultMessage="Extras are subject to parts and technician availability."
          />
        )}
      />
    </div>
  );
};

export default ExtrasFormRender;
